<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full-screen"
      :confirm-loading="confirmLoading"
      :contentStyle="{'height': '100%'}"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>使用模板</span><span class="modal-secondary-title">{{ item.templateName }}</span>
    </template>
    <template #content>
      <el-row class="content-row">
        <el-col class="content-col" :span="12">
          <el-tabs v-model="tabValue">
            <el-tab-pane label="广告活动" name="first" lazy>
              <app-campaign-strategy-tpl-use
                  :tpl="item"
                  :picked-items="tableData"
                  @add-item="addItem"
                  @add-all-item="addAllItem"
              ></app-campaign-strategy-tpl-use>
            </el-tab-pane>
            <el-tab-pane label="广告组" name="second" lazy>
              <app-group-strategy-tpl-use
                  :tpl="item"
                  :picked-items="tableData"
                  @add-item="addItem"
                  @add-all-item="addAllItem"
              ></app-group-strategy-tpl-use>
            </el-tab-pane>
            <el-tab-pane label="关键词" name="third" lazy>
              <app-keyword-strategy-tpl-use
                  :tpl="item"
                  :picked-items="tableData"
                  @add-item="addItem"
                  @add-all-item="addAllItem"
              ></app-keyword-strategy-tpl-use>
            </el-tab-pane>
            <el-tab-pane label="商品投放" name="fourth" lazy>
              <app-product-targeting-strategy-tpl-use
                  :tpl="item"
                  :picked-items="tableData"
                  @add-item="addItem"
                  @add-all-item="addAllItem"
              ></app-product-targeting-strategy-tpl-use>
            </el-tab-pane>
            <el-tab-pane label="投放组" name="five" lazy>
              <app-targeting-group-strategy-tpl-use
                  :tpl="item"
                  :picked-items="tableData"
                  @add-item="addItem"
                  @add-all-item="addAllItem"
              ></app-targeting-group-strategy-tpl-use>
            </el-tab-pane>
            <el-tab-pane label="广告位" name="six" lazy>
              <app-placement-strategy-tpl-use
                  :tpl="item"
                  :picked-items="tableData"
                  @add-item="addItem"
                  @add-all-item="addAllItem"
              ></app-placement-strategy-tpl-use>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col class="content-col" :span="12">
          <app-base-main
              :table-shadow="false"
              parentTable
              style=" padding: 1px 0 0;">
            <template #filter-group>
              <div class="solid"></div>
              <div style="padding-left: 6px;margin-bottom: 6px;">
                <span>已添加数量：{{tableData.length}}</span>
              </div>
            </template>
            <template #table>
              <gj-table
                  adaptParent
                  ref="gjTable"
                  :index="false"
                  :loading="loading"
                  :data="tableData"
                  :columns="columns"
                  :offset-height="74"
                  style="padding-left: 6px;"
                  :show-overflow="false"
                  border="default">
                <template v-slot:header:op>
                  <gj-button
                      type="text"
                      @click="deleteAllItem">移除全部</gj-button>
                </template>
                <template v-slot:objectDisplayName="{row}">
                    <gj-tooltip
                        :text-line="2"
                        :content="row.objectDisplayName">
                      {{row.objectDisplayName | defaultShow}}
                    </gj-tooltip>
                </template>
                 <template v-slot:campaignName="{row}">
                    <gj-tooltip
                        :text-line="2"
                        :content="row.campaignName">
                      {{row.campaignName | defaultShow}}
                    </gj-tooltip>
                </template>
                <template v-slot:op="{row, index}">
                  <gj-button
                      type="text"
                      @click="deleteItem(row, index)">移除</gj-button>
                  <gj-button
                      type="text"
                      @click="preview(row)">预览</gj-button>
                </template>
              </gj-table>
            </template>
          </app-base-main>
        </el-col>
      </el-row>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, responseMixin} from "../../../../../../../minxins";
  import {mapGetters} from "vuex";
  import {AdStrategyEnum} from "../../../common/enum";
  import {AdCampaignEnum} from "../../../../common/enum";
  import AppCampaignStrategyTplUse from "./components/campaign-strategy-tpl-use";
  import AppGroupStrategyTplUse from "./components/group-strategy-tpl-use";
  import AppPlacementStrategyTplUse from "./components/placement-strategy-tpl-use";
  import AppKeywordStrategyTplUse from "./components/keyword-strategy-tpl-use";
  import AppProductTargetingStrategyTplUse from "./components/product-targeting-strategy-tpl-use";
  import AppTargetingGroupStrategyTplUse from "./components/targeting-group-strategy-tpl-use";
  import {batchAddAdsAdjustStrategy} from "../../../../../../../api/ad";
  import {defaultVal} from "../../../../../../../utils/common";
  import AppAdPreviewModal from "@/views/modules/ad/common/modal/preview/ad-preview-modal";

  export default {
    name: "app-strategy-tpl-use-modal",
    components: {
      AppTargetingGroupStrategyTplUse,
      AppProductTargetingStrategyTplUse,
      AppKeywordStrategyTplUse,
      AppPlacementStrategyTplUse,
      AppGroupStrategyTplUse, AppCampaignStrategyTplUse},
    mixins: [modalMixIn, queryMixin, responseMixin],
    props: {
      item: {
        required: true
      }
    },
    data() {
      return {
        tabValue: 'first',
        tableData: [],
        columns: [
          {id: 'marketId', header: '站点', field: 'option:marketId', width: '180px', options: () => this.marketOption},
          {id: 'objectDisplayName', header: '对象', field: 'slot:objectDisplayName', minWidth: '120px'},
          {id: 'objectType', header: '类型', field: 'option:objectType', options: AdStrategyEnum.objectTypeOption, width: '80px'},
          {id: 'campaignName', header: '广告活动', field: 'slot:campaignName', minWidth: '200px'},
          {id: 'groupName', header: '广告组', field: 'groupName', minWidth: '150px'},
          {id: 'state', header: '广告状态', field: 'option:state', width: '80px', options: AdCampaignEnum.SP.statusOption},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '90px', fixed: 'right'},
        ],
        dayNames:[
          {id: 0, text: '周日'},
          {id: 1, text: '周一'},
          {id: 2, text: '周二'},
          {id: 3, text: '周三'},
          {id: 4, text: '周四'},
          {id: 5, text: '周五'},
          {id: 6, text: '周六'},
        ]

      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
      params() {
        return {
          templateId: this.item.id,
          adsStrategyObject: this.tableData.map(item => ({
            templateId: this.item.id,
            marketId: item.marketId,
            bid: item.bid,
            campaignId: item.campaignId,
            campaignName: item.campaignName,
            groupId: defaultVal(item.groupId, null),
            groupName: defaultVal(item.groupName, null),
            objectId: item.objectId,
            objectName: item.objectName,
            objectType: item.objectType,
            adsStatus: item.state,
          }))
        }
      }
    },
    methods: {
      // 预览
      preview(row) {
        let data = this.item.templateExpressionValue
        //获取当前需要预览的数据
        let bidForm = data.bidDailies ? this.getPreviewData(data.bidDailies.expression) : {items:[]};//调整竞价
        let placementBidForm = data.placementDailies ? this.getPreviewData(data.placementDailies.expression) : {items:[]};//调整广告位竞价
        let budgetForm = data.budgetDailies ? this.getPreviewData(data.budgetDailies.expression) : {items:[]};//调整每日预算

        // 生成预览弹窗
        let param = {
          strategy: null,//默认选中的tab
          strategyType: null,//用于区分从哪个父级模块大概此modal
          defaultNum: null, //默认基础值
          form: {
            bidForm: bidForm.items,//调整竞价
            placementBidForm: placementBidForm.items,//调整广告位竞价
            budgetForm: budgetForm.items,//调整每日预算
          }
        }
        //广告活动  默认基础值 === 原始预算
        if (row.objectType === 0) {
          param.strategy = 3;
          param.strategyType = 3
          param.defaultNum = row.dailyBudget
        }
        // 广告位
        else if (row.objectType === 2) {
          param.strategy = 2;
          param.strategyType = 2
        }
        //广告组、关键词、商品投放、投放组  默认基础值 === 原始竞价
        else {
          param.strategy = 1;
          param.strategyType = 1
          param.defaultNum = row.defaultBid
        }
        this.$gjCreate(AppAdPreviewModal, {
          props: param,
        });
      },
      //处理预览数据
      getPreviewData(data){
        //根据需要预览的数据，生成预览展示的数据
        let items = [];
        data.forEach(i => {
          //周日-周六：0-6
          i.dateList.forEach(r => {
            //若选中的是每天 则生成7条数据
            let item = {
              adjustPercent: i.value,
              adjustValue: i.value,
              adjustType: i.budgetType,
              limit: i.max,
              startTime: (i.startHour>=10?i.startHour:'0'+i.startHour)+':00',
              endTime: (i.endHour>=10?i.endHour:'0'+i.endHour)+':00',
              triggerType: i.triggerType,
            }
            if (r === 0) {
              for (let m = 0; m < 7; m++) {
                items.push({
                  day: m,
                  dayName: this.dayNames.find(n => n.id === m).text,
                  ...item
                })
              }
            }
            //若选中的是周日 则day 为0
            else if (r === 7) {
              items.push({
                day: 0,
                dayName: '周日',
                ...item
              })
            }
            //否则
            else {
              items.push({
                day: r,
                dayName: this.dayNames.find(n => n.id === r).text,
                ...item
              })
            }
          })
        })
        return {
          items: this._.sortBy(items,'day','startTime')
        }
      },
      $gjQuery() {
        // this.$nextTick(() => this.tableData = []);
        // 构造查询参数
        // const params = {
        //   model: {
        //     // marketId: this.filter.marketId,
        //     templateId: this.item.id,
        //   },
        //   current: 1,
        //   size: 999999,
        //   // ...this.queryPagination,
        //   ...this.querySort
        // };
        // // 查询
        // this.loading = true;
        // getAdsAdjustStrategyUsePage(params)
        //   .then((data) => {
        //     this.tableData = (data.records || []);
        //     this.pagination = this.getPagination(data);
        //   })
        //   .complete(() => this.loading = false);
      },
      addItem(row) {
        this.tableData.unshift(row);
      },
      addAllItem(rows) {
        this.tableData = rows.concat(this.tableData);
      },
      deleteAllItem() {
        this.tableData = [];
      },
      deleteItem(row, index) {
        this.tableData.splice(index, 1);
      },
      confirm() {
        if (this.formValidate()) {
          this.confirmLoading = true;
          batchAddAdsAdjustStrategy(this.params)
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('添加成功');
                this.$emit('created');
                this.$gjDestroy();
              });
            })
            .complete(() => this.confirmLoading = false);
        }
      },
      formValidate() {
        if (this.tableData.length > 0) {
          return true;
        } else {
          this.$gjMessage.error('请选择要使用模板的对象');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
  /deep/ .el-dialog__body{
    padding-top: 6px;
    padding-bottom: 0;
  }
  /deep/ .el-tabs .vxe-table--border-line{
    border: none;
  }
  /deep/ .el-tabs__content{
    padding-right: 6px;
  }
  .solid{
    width: 100%;
    height: 1px;
    background: #e8e8e8;
    margin-top: 38px;
    margin-bottom: 18px;
    padding-left: 6px;
  }
  /deep/ .el-tabs__item{
     padding: 0 16px;
  }
  .content-row {
    height: 100%;
    .content-col {
      height: 100%;
    }
    
  }
  /deep/ .el-tabs{
      height: 100%;
      display: flex;
      flex-direction: column;
      .el-tabs__content{
        flex: 1;
        overflow: auto;
      }
      .el-tab-pane{
        height: 100%;
      }
    }
</style>
